import React, { useState, useEffect } from 'react'
import { DateTime } from 'luxon'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRectangleAd, faChartBar } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'

const BRAND      = '#6eb446'
const BRAND_DARK = '#2d5918'

interface ActionCardProps {
  icon    : any
  color   : string
  title   : string
  desc    : string
  to      : string
  btnLabel: string
  delay   : string
}

const ActionCard: React.FC<ActionCardProps> = ({ icon, color, title, desc, to, btnLabel, delay }) => (
  <div className="col-sm-6 col-md-4 animate__animated animate__fadeInUp" style={{ animationDelay: delay }}>
    <div style={{
      backgroundColor : '#fff',
      borderRadius    : 18,
      boxShadow       : '0 4px 20px rgba(0,0,0,0.07)',
      border          : '1px solid #f1f5f9',
      overflow        : 'hidden',
      height          : '100%',
      display         : 'flex',
      flexDirection   : 'column',
    }}>
      <div style={{ height: 4, background: `linear-gradient(90deg, ${BRAND_DARK}, ${BRAND})` }} />
      <div style={{
        padding        : '2rem 1.5rem',
        display        : 'flex',
        flexDirection  : 'column',
        alignItems     : 'center',
        textAlign      : 'center',
        flex           : 1,
      }}>
        <div style={{
          width           : 64,
          height          : 64,
          borderRadius    : 16,
          backgroundColor : `${color}15`,
          display         : 'flex',
          alignItems      : 'center',
          justifyContent  : 'center',
          marginBottom    : '1.25rem',
        }}>
          <FontAwesomeIcon icon={icon} style={{ color, fontSize: '1.75rem' }} />
        </div>

        <h5 style={{ margin: '0 0 0.5rem', fontWeight: 800, fontSize: '1rem', color: '#1e293b' }}>
          {title}
        </h5>
        <p style={{ margin: '0 0 1.5rem', fontSize: '0.85rem', color: '#64748b', lineHeight: 1.6, flex: 1 }}>
          {desc}
        </p>

        <Link
          to={to}
          style={{
            padding         : '9px 24px',
            borderRadius    : 9999,
            backgroundColor : color,
            color           : '#fff',
            fontWeight      : 700,
            fontSize        : '0.85rem',
            textDecoration  : 'none',
            boxShadow       : `0 4px 14px ${color}55`,
            transition      : 'filter 0.15s',
          }}
          className="nm-btn-primary"
        >
          {btnLabel}
        </Link>
      </div>
    </div>
  </div>
)

const MarketingDashboard: React.FC = () => {
  const { t, i18n }        = useTranslation()
  const [today, setToday]  = useState(DateTime.now())

  useEffect(() => {
    const interval = setInterval(() => setToday(prev => prev.plus({ seconds: 1 })), 1000)
    return () => clearInterval(interval)
  }, [])

  return (
    <div className="animate__animated animate__fadeIn">

      <h2 className="mb-4" style={{ fontSize: '1.05rem', fontWeight: 700, color: '#475569' }}>
        {t('dashboard.today')}: {today.setLocale(i18n.language).toFormat('yyyy-LLLL-dd HH:mm:ss')}
      </h2>

      <div className="row g-3">
        <ActionCard
          icon={faRectangleAd}
          color={BRAND}
          title={t('sidebar.add_advertising')}
          desc={t('marketing.create_ad_description') || 'Crea y gestiona tus anuncios publicitarios.'}
          to="/marketing/advertising/create"
          btnLabel={t('sidebar.add_advertising')}
          delay="0s"
        />
        <ActionCard
          icon={faChartBar}
          color="#0ea5e9"
          title={t('sidebar.billing')}
          desc={t('marketing.billing_description') || 'Revisa tus pagos y comisiones.'}
          to="/payments/marketing"
          btnLabel={t('sidebar.billing')}
          delay="0.07s"
        />
      </div>

    </div>
  )
}

export default MarketingDashboard
